import { GET_USER_DETAILS, GET_STAKEHOLDER_CATEGORY } from './URLs';
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import jwt from 'jwt-decode';
import { DEMAND_ROLES, MODULE_ACCESS, ROLES, QUALITY_ROLES, RESOURCE_ROLES, PAYMENT_ROLES, HELPDESK_ROLES, PIT_ROLES } from './constants';
import { insertUserLogin, updateStakeholderADB2CId, updateUserADB2CId, clearLocalStorage } from './Utils';
import { loaderService } from './custom-loader/loader-service';
import { useData } from '../App';
import { authorizeCode } from '../registration/screens/registration/commonRegistrationStakeholderAPIs';
import apiClient from '../axios';

export let stakeholderType;
export let userData;

function SpinLoader() {
  let uuid = '';
  const navigate = useNavigate();
  const [emailId, setEmailId] = useState();
  const [userDetails, setUserDetails] = useState();
  const [stakeholderTypedetails, setstakeholderTypedetails] = useState();
  const [ipAddress, setIPAddress] = useState('')
  let isLoginAdded = false;
  const { setEmail, setLastActivityTime, setInactivityThreshold, setLoginUserDetails } = useData();
  const Auth_Code = localStorage.getItem('auth_code');
  const idToken = localStorage.getItem('id_token')
  console.log("idToken Spinloader", idToken)
  let oid = '';
  useEffect(() => {
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        setIPAddress(data.ip);
        localStorage.setItem('ip', data.ip);
      })
      .catch(error => console.log(error))
  }, []);

  useEffect(() => {
    if (Auth_Code) {
      authorizeCode(Auth_Code, null, setInactivityThreshold, setLastActivityTime, setEmail);
    }
  }, [Auth_Code]);

  useEffect(() => {
    if (idToken) {
      const decoded = jwt(idToken);
      if (decoded) {
        oid = decoded.oid;
        setLoginUserDetails({
          adb2c_oid: decoded.oid
        })
      }
      if (decoded.exp < Math.floor(new Date().getTime() / 1000.0)) {
        clearLocalStorage();
      }
      if (!isLoginAdded) {
        isLoginAdded = true;
        insertUserLogin(decoded.extension_URN ? decoded.extension_URN : decoded.emails?.[0], ipAddress);
      }
      if (decoded.extension_URN) {
        if (decoded.newUser == true && decoded.oid) {
          updateStakeholderADB2CId(decoded.extension_URN, decoded.oid);
        }
        loaderService.showLoader();
        apiClient.post(GET_STAKEHOLDER_CATEGORY,
          {
            "urn": decoded.extension_URN,
          },
          {
            headers: {
              Authorization: 'Bearer ' + idToken,
            }
          }
        )
          .then((response) => {
            loaderService.hideLoader();
            if (response && response.data) {
              if (response?.data?.subCategory) {
                // localStorage.setItem('stakeholderCategory', response.data.category);
                localStorage.setItem('stakeholderCategory', response.data.subCategory);
                setstakeholderTypedetails(response.data.subCategory);
                if (response.data?.oid == null || response.data?.oid == '00000000-0000-0000-0000-000000000000' || response.data?.oid == '') {
                  updateStakeholderADB2CId(decoded.extension_URN, decoded.oid);
                }
              }
              else {
                localStorage.setItem('stakeholderCategory', response.data.category === "TemporaryStorage" ? "Interim Storage Operator" : response.data.category);
                setstakeholderTypedetails(response.data.category === "TemporaryStorage" ? "Interim Storage Operator" : response.data.category);
              }

            }
          })
          .catch(function (error) {
            console.log(error);
            loaderService.hideLoader();
          });


      }
      else {
        const email = decoded.emails?.[0];
        setEmailId(email);
        if (decoded.newUser == true && decoded.oid) {
          updateUserADB2CId(email, decoded.oid);
        }
      }
    }
    else if (!Auth_Code) {
      window.location.replace(window.location.origin);
      window.history.replaceState(null, null, "/");
    }
  }, [idToken]);

  useEffect(() => {
    if (stakeholderTypedetails) {
      stakeholderType = stakeholderTypedetails;
      navigate('/dashboardHome/dashboardStakeHolder');
    }
  }, [stakeholderTypedetails]);

  useEffect(() => {
    if (emailId) {
      getUserDetails();
    }
  }, [emailId]);

useEffect(() => {
  if (userDetails) {
    const role = userDetails?.user?.userRoles?.[0]?.roleName;
    const userid = userDetails?.user?.id;
    setLoginUserDetails({
      userId
        : userid,
      adb2c_oid: userDetails?.user?.adb2cOid
    })
    uuid = userid;
    userData = userDetails
    localStorage.setItem('uuid', userid);
    localStorage.setItem('InspectorEmail', userDetails?.user?.emailAddress);
 
    if (
      role == ROLES.RegistrationScruitnizer ||
      role == ROLES.LeadRegScrutinizer ||
      role == ROLES.RegInCharge ||
      role == ROLES.RegAssistant ||
      role == ROLES.RegSuperVisor ||
      role == ROLES.RegSCMUser
    ) {
      navigate("/registrationHome/dashboard");
    }
    else if (role == ROLES.ItAdmin) {
      navigate("/sidebar/onboardingStakeholders");
    }
    else if (role == ROLES.UserOnboarding) {
      navigate("/sidebar/onboardingStakeholders");
    } 
    else if (role == ROLES.SCMInCharge) {
      navigate("/userOnboardingApproval");
    }
    else if (role === DEMAND_ROLES.DemandPlanner) {
      navigate('/demandDashboard/yearlyInput')
    } else if (role === DEMAND_ROLES.DemandModuleIncharge) {
      navigate('/demandDashboard/monthlyAllocation')
    }
    // else if (role === "Processing Incharge") {
    //   navigate('/demandDashboard/monthlyAllocation')
    // }
    else if (role === DEMAND_ROLES.ProcurementLead) {
      navigate('/demandDashboard/monthlyAllocation')
    }
    else if (role === PAYMENT_ROLES?.SCMEndUser) {
      navigate('/paymentDashboard/advancePayment')
    }
    else if (role === PAYMENT_ROLES?.PaymentApprover) {
      navigate('/paymentDashboard/advancePayment')
    }
    else if (role === PAYMENT_ROLES?.FinanceUser) {
      navigate('/paymentDashboard/advancePayment')
    }
    else if (role === PAYMENT_ROLES?.Updater) {
      navigate('/paymentDashboard/PaymentStatusABRPLUser')
    }
    else if (role === QUALITY_ROLES?.QualityModuleIncharge) {
      navigate('/qualityDashboard/home')
    }
    else if (role === QUALITY_ROLES?.Inspector) {
      navigate('/qualitydashboard/inspectionworkorder')
    }
    else if (role === QUALITY_ROLES?.ScmUser) {
      navigate('/qualitydashboard/home')
    } 
    else if (
      (role === RESOURCE_ROLES?.PlantSCMMember) ||
      (role === RESOURCE_ROLES?.ModuleIncharge) ||
      (role === RESOURCE_ROLES?.SuperAdmin) ||
      (role === RESOURCE_ROLES?.ResourceScrutinizer) ||
      (role === RESOURCE_ROLES?.FinanceUser) ||
      (role === RESOURCE_ROLES?.CommercialUser)
    ) {
      navigate('/resourcedashboard/home')
    }
     else if (
      (role == HELPDESK_ROLES?.HelpdeskTeamMember) ||
      (role == HELPDESK_ROLES?.HelpdeskSupportExecutive) ||
      (role == HELPDESK_ROLES?.HelpdeskAssistant) ||
      (role == HELPDESK_ROLES?.SMUSer) ||
      (role == HELPDESK_ROLES?.ExternalSupportExecutive)
    ) {
      navigate('/helpDeskDashboard/requests')
    }
     else if (
      role == HELPDESK_ROLES.HelpdeskAdminUser ||
      role === HELPDESK_ROLES?.ExternalAdminUser
    ) {
      navigate("/helpDeskDashboard/helpDeskDashboard")
    }
     else if (
      role === PIT_ROLES?.PitUnloader ||
      role === PIT_ROLES?.PitWeighbridgeOperator ||
      role === PIT_ROLES?.PitManualWeighbridgeOperator
    ) {
      navigate('/asnGRN')
    }
    else if (
      role === PIT_ROLES?.PitApprover ||
      role === PIT_ROLES?.ProcessingIncharge ||
      role === PIT_ROLES?.ProcurementLead
    ) {
      navigate('/pitWorkflowDashboard')
    }
    else if (role === PIT_ROLES?.Incharge) {
      navigate('/spotBiddingApproval')
    }
    else if (role === PIT_ROLES?.PlantSCMOperator) {
      navigate('/dbsScheduleCreation')
    }
    else if (
      role === PIT_ROLES?.PitScmUser ||
      role === PIT_ROLES?.TransportationIncharge
    ) {
      navigate('/trDashboard')
    }
    else if (role === PIT_ROLES?.PitProcessingPlant) {
      navigate('/rbScheduleApproval')
    }
    else if (role === PIT_ROLES?.Loader) {
      navigate('/consignmentPickupTracker')
    }
 
    else {
      navigate("/sideBar");
    }
  }
}, [userDetails]);

  useEffect(() => {
    if (stakeholderTypedetails) {
      stakeholderType = stakeholderTypedetails;

      // clear user-only selections from previous normal-user login
      localStorage.removeItem("role");
      localStorage.removeItem("module");

      //  force correct stakeholder landing path every time
      const targetPath = "/dashboardHome/dashboardStakeHolder";
      localStorage.setItem("home_path", targetPath);

      //  replace to avoid history pollution
      navigate(targetPath, { replace: true });
    }
  }, [stakeholderTypedetails]);

  function getUserDetails() {
    const decoded = jwt(idToken);
    loaderService.showLoader();
    apiClient
      .post(GET_USER_DETAILS,
        {
          "emailAddress": emailId
        },
        {
          headers: {
            Authorization: 'Bearer ' + idToken,
          }
        }, null
      )
      .then((response) => {
        setUserDetails(response.data);
        if (response.data.user.adb2cOid == null || response.data.user.adb2cOid == '' || response.data.user.adb2cOid == '00000000-0000-0000-0000-000000000000') {
          updateUserADB2CId(emailId, decoded.oid);
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
      });
  }

  return (
    <div style={{ marginLeft: "45vw", marginTop: "30vh" }}>
      {/* <TailSpin
        height="80"
        width="80"
        color="#4fa94d"
        ariaLabel="tail-spin-loading"
        radius="1"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      /> */}
    </div>
  );
};
export default SpinLoader;
